module.exports = __webpack_public_path__ + "static/media/vc.bbb52fa0.svg";